<template>
  <v-main>
    <v-container class="mt-16">
      <v-row
        justify="center"
        class="launcher"
      >
        <v-col
          cols="12"
          align="center"
        >
          <div class="text-h4 font-weight-bold mb-6">
            ¿A qué módulo desea acceder?
          </div>
        </v-col>
        <v-col
          v-if="perfil === PROGRAMACION || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-calendar-clock
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Programación
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterProgramacion()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === PSICOLOGIA || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-brain
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Evaluaciones psicológicas
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterPsico()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === ISE || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-account-search
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Investigación socioeconómica
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterIse()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === ANTECEDENTES || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-account-search
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Antecedentes
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterAntecedentes()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === VALIDACION || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-account-search
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Validación
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterValidacion()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === MEDICO || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-medical-bag
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Evaluaciones médicas
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterMedico()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === POLIGRAFO || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            class="primary-shadow"
            color="primary"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-clipboard-pulse
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Evaluaciones poligráficas
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterPoligrafo()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="perfil === INTEGRACION || perfil === ADMIN"
          cols="12"
          lg="4"
        >
          <v-card
            color="primary"
            class="primary-shadow"
          >
            <v-card-title
              class="d-block justify-center"
              align="center"
            >
              <v-icon
                size="80"
                color="secondary"
              >
                mdi-book-check
              </v-icon>
              <div class="font-weight-black text-h6 py-4">
                Integración
              </div>
            </v-card-title>
            <v-card-text
              align="center"
              class="text--primary text-body-2"
            >
              Descripción de funcionalidades del módulo
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                rounded
                class="mb-4 px-8"
                color="secondary"
                elevation="8"
                @click="enterIntegracion()"
              >
                Entrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ROLES from '../roles';

const {
  PROGRAMACION,
  PSICOLOGIA,
  ISE,
  ANTECEDENTES,
  VALIDACION,
  MEDICO,
  POLIGRAFO,
  INTEGRACION,
  ADMIN,
} = ROLES;

export default {
  name: 'LauncherView',

  data() {
    return {
      PROGRAMACION,
      PSICOLOGIA,
      ISE,
      ANTECEDENTES,
      VALIDACION,
      MEDICO,
      POLIGRAFO,
      INTEGRACION,
      ADMIN,
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters({
      idPersonal: 'getIdPersonal',
    }),
  },

  methods: {
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER', 'SET_PERFIL']),

    enterIntegracion() {
      this.SET_PERFIL('Integración');
      this.$router.push('integracion/personal');
    },

    enterPoligrafo() {
      this.SET_PERFIL('Poligrafía');
      this.$router.push('/evaluaciones_poligraficas/personal');
    },

    enterMedico() {
      this.SET_PERFIL('Médico');
      this.$router.push('/evaluaciones_medicas/personal');
    },

    enterIse() {
      this.SET_PERFIL('ISE');
      this.$router.push('/investigacion_socioeconomica/expedientes');
    },

    enterPsico() {
      this.SET_PERFIL('Psicología');
      this.$router.push('/evaluaciones_psicologicas/personal');
    },

    enterProgramacion() {
      this.SET_PERFIL('Programación');
      this.$router.push('/programacion/expedientes');
    },

    enterAntecedentes() {
      this.SET_PERFIL('Antecedentes');
      this.$router.push('/investigacion_socioeconomica/antecedentes');
    },

    enterValidacion() {
      this.SET_PERFIL('Validación');
      this.$router.push('/investigacion_socioeconomica/validacion');
    },
  },
};
</script>

<style scoped>
    .text-armory {
        color: #dadaf2 !important;
    }
</style>
